import { useUserName } from './useLocalStorage'

export const useIsLoginMember = (name: string) => {
  const { value: selfName } = useUserName()
  return selfName === name
}
